import React from 'react'

import './empty-history.scss'

import Button from "../../../shared/components/atoms/button/button";

const EmptyHistory = props => {
    const { message, titlebtn, action } = props
    return (
        <div className="f-empty-history">
            <div className="f-empty-history-container">
                <div className="f-empty-history-container-info">
                    <p className='f-empty-history-message'>{message}</p>
                    <Button title={titlebtn} className="primary-pink custom-btn" onClick={action} />
                </div>
            </div>
        </div>
    )
}

export default EmptyHistory
